import React from 'react';
import PatientLabelDialog from './Dialogs/PatientLabelDialog';
import ShippingLabelDialog from './Dialogs/ShippingLabelDialog';
import BundleCompletionDialog from './Dialogs/BundleCompletionDialog';
import UpdateRxFormShippingDialog from './Dialogs/UpdateRxFormShippingDialog';

const ShipmentDialog = () => {
  return (
    <>
      <PatientLabelDialog />
      <ShippingLabelDialog />
      <BundleCompletionDialog />
      <UpdateRxFormShippingDialog />
    </>
  );
};

ShipmentDialog.propTypes = {};

export default ShipmentDialog;
